module.exports = __webpack_public_path__ + "static/media/uwm.00805600.png";